// extracted by mini-css-extract-plugin
module.exports = {"bottomspacing":"Articles_bottomspacing__toF2R","pagination":"Articles_pagination__FxfnM"};